import UseAuthContext from 'context/AuthContext';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { USER_ROLES } from 'utils/constants';

const RoleBasedRedirect = () => {
  const { role } = useContext(UseAuthContext);

  // Redirect inspectors and inspector managers to inspections page
  const redirectPath = (role === USER_ROLES.INSPECTOR || role === USER_ROLES.INSPECTOR_MANAGER)
    ? '/inspections'
    : '/dashboard';

  return <Navigate to={redirectPath} replace />;
};

export default RoleBasedRedirect;
